"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PortalHeader = void 0;
var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");
var _faEnvelope = require("@fortawesome/pro-light-svg-icons/faEnvelope");
var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _theme = require("../../../../theme");
var _MenuDropdownItem = _interopRequireDefault(require("../../../atoms/MenuDropdownItem/MenuDropdownItem"));
var _GhostButton = require("../../../button/GhostButton");
var _Menu = _interopRequireDefault(require("../../../molecules/Menu/Menu"));
var _Tooltip = require("../../../Tooltip");
var _Sidebar = require("../../Sidebar");
var _PortalHeader = require("./PortalHeader.styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PortalHeader = function PortalHeader(props) {
  var classes = (0, _PortalHeader.useStyles)();
  var _useTheme = (0, _theme.useTheme)(),
    fullLogo = _useTheme.images.fullLogo;
  var _useContext = (0, _react.useContext)(_Sidebar.SidebarContext),
    isOpen = _useContext.isOpen,
    toggle = _useContext.toggle;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    openContactInfo = _useState4[0],
    setOpenContactInfo = _useState4[1];
  var userTitle = props.userTitle,
    userAccount = props.userAccount,
    dropDownItems = props.dropDownItems,
    testId = props.testId,
    menuButtonTestId = props.menuButtonTestId,
    dropDownDisabled = props.dropDownDisabled,
    showContactInfo = props.showContactInfo,
    contactInfo = props.contactInfo,
    showNotifications = props.showNotifications,
    newNotifications = props.newNotifications,
    handleOpenNotifications = props.handleOpenNotifications;
  var contactDropDownItems = [{
    underline: false,
    disableHoverEffect: true,
    content: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        width: '266px'
      }
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      style: {
        fontWeight: 600
      }
    }, "Need help? Get in Touch."), /*#__PURE__*/_react["default"].createElement("h3", {
      style: {
        fontWeight: 600
      }
    }, "Client Services"), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _proLightSvgIcons.faPhone,
      style: {
        fontSize: '18px',
        color: '#098475',
        marginRight: '8px'
      }
    }), ' ', /*#__PURE__*/_react["default"].createElement("a", {
      href: "tel:".concat((contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.phone) || ''),
      style: {
        textDecoration: 'none',
        color: '#222',
        fontSize: '16px'
      }
    }, (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.phone) || '')), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faEnvelope.faEnvelope,
      style: {
        fontSize: '18px',
        color: '#098475',
        marginRight: '8px'
      }
    }), ' ', /*#__PURE__*/_react["default"].createElement("a", {
      href: "mailto:".concat((contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.email) || ''),
      style: {
        textDecoration: 'none',
        color: '#222',
        fontSize: '16px'
      }
    }, (contactInfo === null || contactInfo === void 0 ? void 0 : contactInfo.email) || '')))),
    arrow: false,
    disableClick: true
  }];
  var contactComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    open: Boolean(openContactInfo),
    setOpen: setOpenContactInfo,
    buttonTitle: /*#__PURE__*/_react["default"].createElement(_Tooltip.Tooltip, {
      title: "Contact Us",
      arrow: true,
      placement: "bottom"
    }, /*#__PURE__*/_react["default"].createElement(_GhostButton.GhostButton, {
      style: {
        minWidth: '20px',
        width: '20px',
        height: '20px',
        color: 'white',
        background: 'transparent'
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _proSolidSvgIcons.faQuestionCircle,
      style: {
        fontSize: '16px',
        color: 'white',
        background: 'transparent'
      }
    }))),
    anchorEl: openContactInfo,
    menuItemProps: {
      style: {
        fontSize: 14,
        fontWeight: 500
      }
    },
    buttonProps: {
      disableRipple: true,
      style: {
        background: 'transparent'
      }
    },
    hideIcon: true
  }, contactDropDownItems.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MenuDropdownItem["default"], {
      setOpen: setOpenContactInfo
    }, item);
  })), /*#__PURE__*/_react["default"].createElement(_core.Divider, {
    style: {
      height: '20px',
      minHeight: '20px',
      margin: '0px 13px',
      borderRight: '1px #666 solid'
    }
  }));
  var notificationsComponent = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Badge, {
    className: classes.badge,
    badgeContent: newNotifications,
    variant: "standard"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proRegularSvgIcons.faBell,
    color: "#FFFFFF",
    className: classes.bell,
    onClick: handleOpenNotifications
  })), /*#__PURE__*/_react["default"].createElement(_core.Divider, {
    style: {
      height: '20px',
      minHeight: '20px',
      margin: '0px 13px',
      borderRight: '1px #666 solid'
    }
  }));
  return /*#__PURE__*/_react["default"].createElement("header", {
    className: classes.root,
    "data-testid": testId
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapperLeft
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(classes.menuButton, isOpen ? 'open' : ''),
    onClick: toggle,
    "data-testid": menuButtonTestId
  }, /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("span", null))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.wrapperRight
  }, showContactInfo ? contactComponent : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), showNotifications ? notificationsComponent : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
    open: Boolean(open),
    setOpen: setOpen,
    anchorEl: open,
    buttonTitle: userTitle,
    userAccount: userAccount,
    menuItemProps: {
      style: {
        fontSize: 14,
        fontWeight: 500
      }
    },
    buttonProps: {
      disableRipple: true,
      className: dropDownDisabled ? classes.disabledButton : classes.button
    },
    menuIconProps: {
      icon: _proRegularSvgIcons.faAngleDown,
      style: {
        fontSize: 16
      }
    },
    dropDownIconEndProps: {
      icon: _proRegularSvgIcons.faAngleRight,
      style: {
        fontSize: 16
      }
    },
    menuProps: {
      anchorOrigin: {
        vertical: 55,
        horizontal: 'right'
      }
    }
  }, dropDownItems.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_MenuDropdownItem["default"], {
      setOpen: setOpen,
      key: item.key
    }, item);
  })), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.NavLink, {
    to: "/",
    className: (0, _classnames["default"])(classes.logoParent)
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("img", {
    alt: "logo",
    src: fullLogo,
    className: classes.logo
  })))));
};
exports.PortalHeader = PortalHeader;